var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('device-and-playlist-layout',{attrs:{"deviceView":false,"title":"Playlists"}})}
var staticRenderFns = []

export { render, staticRenderFns }